<template>
  <div class="subtitle" :class="isUppercase">
    {{ title }}
  </div>
</template>

<script>
export default {
  name: "SubTitle",
  props: {
    title: {
      type: String,
    },
    uppercase: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isUppercase() {
      return this.uppercase ? "subtitle_uppercase" : "";
    },
  },
};
</script>

<style lang="scss" scoped>
.subtitle {
  max-width: fit-content;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  @include font("CeraPro", 36px, 700);

  &_uppercase {
    text-transform: uppercase;
  }
}

@media screen and (max-width: 600px) {
  .subtitle {
    font-size: 28px;
  }
}

@media screen and (max-width: 420px) {
  .subtitle {
    font-size: 22px;
  }
}
</style>
